import { BodyText, HeadlineBodyText } from "src/components/KinsaTypography";
import { CaseListError } from "@repo/provider-network";
import { SUPPORT_EMAIL } from "src/lib/product-name";

interface VisitListErrorProps {
  error: CaseListError | Error;
  className?: string;
}

const VisitListError: React.FC<VisitListErrorProps> = ({
  error,
  className,
}) => {
  const customErrorMessage =
    error instanceof Error
      ? error.message
      : "message" in error
        ? error.message
        : null;

  return (
    <div
      className={`flex flex-col items-center justify-center min-h-[60vh] py-12 px-6 text-center ${className || ""}`}
    >
      <HeadlineBodyText className="text-text-300 mb-3">
        Something went wrong
      </HeadlineBodyText>
      <BodyText className="text-text-200 max-w-sm leading-relaxed mb-4">
        We couldn&apos;t load your information at the moment. Please close the
        app and try again. If the issue continues, contact support at{" "}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline">
          {SUPPORT_EMAIL}
        </a>
        .
      </BodyText>
      {customErrorMessage && (
        <BodyText className="text-text-300 max-w-sm leading-relaxed text-sm">
          {customErrorMessage}
        </BodyText>
      )}
    </div>
  );
};

export default VisitListError;
